"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactProvider = require("@trycourier/react-provider");

var _react = require("react");

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var _useInboxActions = _interopRequireDefault(require("./use-inbox-actions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useInbox = function useInbox() {
  var _useCourier = (0, _reactProvider.useCourier)(),
      dispatch = _useCourier.dispatch,
      inbox = _useCourier.inbox,
      transport = _useCourier.transport,
      brand = _useCourier.brand,
      tenantId = _useCourier.tenantId;

  var actions = (0, _useInboxActions["default"])();

  if (inbox && (brand || inbox.brand)) {
    var _inbox$brand;

    inbox.brand = (0, _deepExtend["default"])({}, brand !== null && brand !== void 0 ? brand : {}, (_inbox$brand = inbox.brand) !== null && _inbox$brand !== void 0 ? _inbox$brand : {});
  }

  if (inbox && tenantId) {
    inbox.tenantId = tenantId;
  }

  (0, _react.useEffect)(function () {
    transport === null || transport === void 0 ? void 0 : transport.listen({
      id: "message-listener",
      type: "message",
      listener: function listener(courierEvent) {
        if (!dispatch || !(courierEvent !== null && courierEvent !== void 0 && courierEvent.data)) {
          return;
        }

        actions.newMessage(courierEvent === null || courierEvent === void 0 ? void 0 : courierEvent.data);
      }
    });
    transport === null || transport === void 0 ? void 0 : transport.listen({
      id: "event-listener",
      type: "event",
      listener: function listener(courierEvent) {
        var data = courierEvent === null || courierEvent === void 0 ? void 0 : courierEvent.data;

        if (!dispatch || !data || !(data !== null && data !== void 0 && data.event)) {
          return;
        }

        if (data.event === "mark-all-read") {
          actions.markAllAsRead(true);
        }

        if (!(data !== null && data !== void 0 && data.messageId)) {
          return;
        }

        switch (data.event) {
          case "read":
            {
              actions.markMessageRead(data.messageId, true);
              return;
            }

          case "opened":
            {
              actions.markMessageOpened(data.messageId, true);
              return;
            }

          case "unread":
            {
              actions.markMessageUnread(data.messageId, true);
              return;
            }

          case "unpin":
            {
              actions.unpinMessage(data.messageId, true);
              return;
            }

          case "archive":
            {
              actions.markMessageArchived(data.messageId, true);
              return;
            }
        }
      }
    });
  }, [transport]);
  return _objectSpread(_objectSpread({}, inbox), actions);
};

var _default = useInbox;
exports["default"] = _default;